import { useQuery } from '@tanstack/react-query';
import { getHighlights } from '../../../services/general';
import { COMMUNITY_HIGHLIGHTS } from './key';

export default function useGetCommunityHighlights({ state, market, community, id }) {
  return useQuery({
    queryKey: [COMMUNITY_HIGHLIGHTS, id],
    queryFn: async () => {
      const params = { state, market, community, id };

      const data = await getHighlights(params);

      return data;
    },
    enabled: !!id,
  });
}
